import React, { useEffect, useState } from "react";
import productAPI from "../../api/productApi";
import Product from "../products/Card";

function SearchCanvas({ isOpen }) {
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [page, setPage] = useState(1);

  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    fetchProducts(1, searchText);
  }, [searchText]);

  const fetchProducts = async (pageNum = 1, searchText) => {
    setLoading(true);

    try {
      if (searchText) {
        const res = await productAPI.listing({
          page: pageNum,
          limit: 6,
          keyword: searchText,
        });

        if (res.code === 200) {
          const { products, base_url } = res.data;

          const items = products;

          setProducts((prev) => (pageNum === 1 ? items : [...prev, ...items]));
        }
      }
    } catch (err) {
      console.error("Error loading products:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
 <div className="modal-dialog modal-fullscreen">
  <div className="modal-content search-canvas">

    {/* HEADER */}
    <div className="search-header d-flex justify-content-between align-items-center px-4 py-3">
      <h5 className="mb-0">Search Products</h5>
      <button
        className="btn-close"
        data-bs-dismiss="modal"
      ></button>
    </div>

    {/* SEARCH BAR */}
    <div className="container py-4">
      <div className="row justify-content-center">
        <div className="col-lg-6">
          <form className="form-search position-relative">
            <input
              type="text"
              className="form-control search-input"
              placeholder="Search for products..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
            {/* <i className="icon-search search-icon"></i> */}
          </form>
        </div>
      </div>

      {/* RESULTS */}
      <div className="mt-4">
        {loading ? (
          <div className="text-center py-5">Loading...</div>
        ) : products.length > 0 ? (
          <div className="row g-4">
            {products.map((product) => (
              <div className="col-lg-3 col-md-4 col-6" key={product._id}>
                <Product item={product} />
              </div>
            ))}
          </div>
        ) : searchText ? (
          <div className="text-center py-5">
            No products found 😔
          </div>
        ) : (
          <div className="text-center py-5 text-muted">
            Start typing to search...
          </div>
        )}
      </div>
    </div>
  </div>
</div>
  );
}

export default SearchCanvas;
